exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientView-actions {\n  display: flex; }\n  .PatientView-actions > * {\n    margin-right: 16px; }\n\n.PatientView-userCard {\n  margin: 0 0 24px; }\n  .PatientView-userCard-name {\n    margin: 0; }\n  .PatientView-userCard-email {\n    color: #666b72; }\n", ""]);

// exports
